import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import ButtonCard from "./ButtonCard";
import './ButtonCards.scss';

const GET_BUTTONCARDS = gql`
query paragraphById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentButtonCards {
          fieldButtonCards {
            ... on FieldParagraphFieldButtonCards {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerButtonCard {
                    fieldBackgroundColor
                    fieldTextColor
                    fieldLink {
                      ... on FieldParagraphFieldLink {
                        url {
                          path
                          routed
                        }
                        title
                      }
                    }
                    fieldTxtHeadline
                    fieldTxtSubTitle
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

const ButtonCards = ({id, markComponentLoadedAs}) => (
    <Query asyncMode query={GET_BUTTONCARDS} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const buttonCards = field.fieldButtonCards && field.fieldButtonCards.length ? field.fieldButtonCards : null;

            markComponentLoadedAs(id, true);

            if (!buttonCards.length) return null;

            let cardsPerRow = 5;
            if (buttonCards.length >= 1 && buttonCards.length <= 5) {
                cardsPerRow = buttonCards.length;
            }

            return (
                <div className={`buttonCards buttonCards--${cardsPerRow}`}>
                    {buttonCards.length ? buttonCards.filter(buttonCard => buttonCard.entity && buttonCard.entity.fieldLink && buttonCard.entity.fieldLink.url).map(buttonCard => (
                        <ButtonCard buttonCard={buttonCard}/>
                    )) : null}
                </div>

            );
        }}
    </Query>
);

ButtonCards.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired
};

export default ButtonCards;



// WEBPACK FOOTER //
// ./frontend/components/ButtonCards/ButtonCards.jsx